module.exports = __webpack_public_path__ + "media/images/gallery/constellations/auriga/aur_oc-995a167c063a74c21143f95fbf5f6837.gif";